import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaHome } from 'react-icons/fa';
import NavBar from '../components/nav';
import { Footer } from '../components/footer';

const DG = 'rgb(5, 70, 37)';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <>
      <NavBar />
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 pt-24 pb-16">
        <div className="max-w-xl w-full text-center">
          <p className="text-8xl font-bold" style={{ color: DG }}>404</p>
          <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-gray-900">
            {t('notFound.title')}
          </h1>
          <p className="mt-3 text-gray-600">
            {t('notFound.description')}
          </p>

          <div className="mt-8 flex items-center justify-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-white font-semibold text-sm transition-opacity hover:opacity-90"
              style={{ backgroundColor: DG }}
            >
              <FaHome size={14} />
              {t('notFound.backToHome')}
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
